import {
    USUARI_INICIALITZAR,
    USUARI_INTRODUCCIO_OMPLIR_DADES
} from '../../../../actions/actionTypes';

const ESTAT_INICIAL = {
    nom: null,
    cognom1: null,
    cognom2: null,
    codi: null,
    telefon: null,
    email: null,
    idRol: null,
    codiINEMunicipi: null,
    carrer: null,
    numero: null,
    pis: null,
    porta: null,
    codiPostal: null,
    dataAlta: null,
    dataBaixa: null
};

const originals = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {
        case USUARI_INICIALITZAR:
            return ESTAT_INICIAL;

        case USUARI_INTRODUCCIO_OMPLIR_DADES:
            return action.dades;

        default:
            return state;
    }
};

export default originals;



// WEBPACK FOOTER //
// ./src/reducers/usuari/formulari/dades/originals.js